var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2724_64268",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2724_64268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4 17.95C14.95 17.9667 14.5208 17.9792 14.1125 17.9875C13.7042 17.9958 13.3417 18 13.025 18H12C10.8167 18 9.70833 17.9833 8.675 17.95C7.79167 17.9167 6.92083 17.8708 6.0625 17.8125C5.20417 17.7542 4.58333 17.675 4.2 17.575C3.76667 17.4583 3.39167 17.2417 3.075 16.925C2.75833 16.6083 2.54167 16.2333 2.425 15.8C2.325 15.4167 2.24583 14.95 2.1875 14.4C2.12917 13.85 2.08333 13.325 2.05 12.825C2.01667 12.225 2 11.6167 2 11C2 10.3833 2.01667 9.775 2.05 9.175C2.08333 8.675 2.12917 8.15 2.1875 7.6C2.24583 7.05 2.325 6.58333 2.425 6.2C2.54167 5.76667 2.75833 5.39167 3.075 5.075C3.39167 4.75833 3.76667 4.54167 4.2 4.425C4.58333 4.325 5.20417 4.24583 6.0625 4.1875C6.92083 4.12917 7.79167 4.08333 8.675 4.05C9.70833 4.01667 10.8167 4 12 4C13.1833 4 14.2917 4.01667 15.325 4.05C16.2083 4.08333 17.0792 4.12917 17.9375 4.1875C18.7958 4.24583 19.4167 4.325 19.8 4.425C20.2333 4.54167 20.6083 4.75833 20.925 5.075C21.2417 5.39167 21.4583 5.76667 21.575 6.2C21.675 6.58333 21.7542 7.05 21.8125 7.6C21.8708 8.15 21.9167 8.675 21.95 9.175C21.9833 9.775 22 10.3833 22 11V11.425C21.6833 11.2917 21.3583 11.1875 21.025 11.1125C20.6917 11.0375 20.35 11 20 11C18.6167 11 17.4375 11.4875 16.4625 12.4625C15.4875 13.4375 15 14.6167 15 16C15 16.35 15.0333 16.6875 15.1 17.0125C15.1667 17.3375 15.2667 17.65 15.4 17.95ZM10 14L15.2 11L10 8V14ZM19 19V17H17V15H19V13H21V15H23V17H21V19H19Z",
    fill: "#707072"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.cfa2660f.svg";
export { ForwardRef as ReactComponent };